<div class="posted-order-line-items--wrapper relative">
  <table class="lum-table lum-table--classic striped">
    <thead>
      <tr class="table__head-row">
        <th>Ordered SKU</th>
        <th>Order Product Name</th>
        <th>Estimated Arrival Date</th>
        <th>Location</th>
        <th>Lot</th>
        <th>Ordered Quantity</th>
        <th>Quantity Available</th>
        <th width="30px">&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let pickingItem of pickingItems; trackBy: trackByValue">
        <tr [ngClass]="{ 'text-danger': !pickingItem.fulfilled }">
          <td>{{ pickingItem?.rfq?.internal_sku }}</td>
          <td>{{ pickingItem?.rfq?.product_name }}</td>
          <td class="text-nowrap">
            <ng-container
              *ngIf="
                pickingItem?.incomingOrders && pickingItem?.incomingOrders?.length
              "
            >
              <ul class="incoming-orders-list">
                <li
                  *ngFor="
                    let incomingOrder of pickingItem?.incomingOrders;
                    trackBy: trackById
                  "
                >
                  <a
                    [routerLink]="['/orders', incomingOrder?.purchase_order?.id]"
                    routerLinkActive="router-link-active"
                  >
                    {{
                      (incomingOrder?.purchase_order?.arrival_due_date
                        | date: 'mediumDate') || 'N/A'
                    }}
                    <span class="font-italic"
                      >x{{ incomingOrder?.ordered_qty | decimalPlaces }}</span
                    >
                  </a>
                </li>
              </ul>
            </ng-container>
          </td>
          <td class="text-nowrap">
            <span *ngIf="pickingItem.warehouse">
              {{ pickingItem?.warehouse?.location_name }} >>
              {{ pickingItem?.location?.location_name }}
            </span>
          </td>
          <td>{{ pickingItem?.lot?.lot_number }}</td>
          <td class="text-center">
            {{ pickingItem?.orderedQuantity | decimalPlaces }}
          </td>
          <td class="text-center">
            {{ pickingItem?.availableQuantity | decimalPlaces }}
          </td>
          <td class="table__actions">
            <button mat-icon-button [matMenuTriggerFor]="menu">
              <i class="flaticon-more"></i>
            </button>
            <mat-menu #menu="matMenu">
              <button
                mat-menu-item
                (click)="createAdjustmentEntry(pickingItem.rfqId)"
              >
                Create Adjustment Entry
              </button>
            </mat-menu>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
